export default __webpack_public_path__ + "static/media/ICO-arrow.2afb6cba.svg";